// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2ZjzB","card":"Cards_card__2gm0p","infected":"Cards_infected__13Ef_","recovered":"Cards_recovered__3KqSj","deaths":"Cards_deaths__1gsx5"};